import { useMemo } from 'react';

import { ScanDateOption, ScanMetadata } from '../../interfaces/scanMetadata';
import { useScanDateOptions } from '../useScanDateOptions/useScanDateOptions';

export type UseScanRangeOptionsProps = {
  scansMetadata: ScanMetadata[]; // should be sorted by scanDateTime
  startScanId: number | null;
  endScanId: number | null;
};

export type UseScanRangeOptionsReturn = {
  startScanOptions: ScanDateOption[];
  endScanOptions: ScanDateOption[];
};

export const useScanRangeOptions = ({
  scansMetadata,
  startScanId,
  endScanId,
}: UseScanRangeOptionsProps): UseScanRangeOptionsReturn => {
  const scanOptions = useScanDateOptions(scansMetadata);

  const getScanIndex = (scanId: number) =>
    scanOptions.findIndex((scan) => scan.value === scanId);

  const startScanOptions = useMemo(() => {
    if (!endScanId) {
      return scanOptions.slice(1);
    }

    const endScanIndex = getScanIndex(endScanId);

    return scanOptions.slice(endScanIndex + 1);
  }, [scanOptions, endScanId]);

  const endScanOptions = useMemo(() => {
    if (!startScanId) {
      return scanOptions.slice(0, -1);
    }

    const startScanIndex = getScanIndex(startScanId);

    return scanOptions.slice(0, startScanIndex);
  }, [scanOptions, startScanId]);

  return { startScanOptions, endScanOptions };
};
